import React, { useContext } from "react";
import { useHistory, useLocation, Redirect } from "react-router";
import { makeStyles } from "@material-ui/core";
import Container from "@material-ui/core/Container";
import Axios from "axios";
import "typeface-roboto";
import "./App.css";
import useSpinner from "./hooks/spinner/useSpinner";
import UserContext from "./UserContext";
import Routing from "./Routing";
import Header from "./components/shared/common/Header";
import SideNav from "./components/shared/common/SideNav";
import TrSpinner from "./components/shared/controls/TrSpinner";
import { loginUrl } from "./urls";
import useSnackbar from "./hooks/snackbar/useSnackbar";
import TrSnackbar from "./components/shared/controls/TrSnackbar";

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    backgroundColor: "#f4f6f8"
  },
  content: {
    flexGrow: 1,
    height: "100vh",
    overflow: "auto"
  },
  appBarSpacer: theme.mixins.toolbar,
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4)
  }
}));

export default function App() {
  const classes = useStyles({});
  const history = useHistory();
  const location = useLocation();
  const {
    isShown: isSpinnerShown,
    show: showSpinner,
    hide: hideSpinner
  } = useSpinner();

  const { user, logoutUser } = useContext(UserContext);

  const {
    isOpened: isSnackbarOpened,
    open: openSnackbar,
    close: closeSnackbar,
    message: snackbarMessage,
    variant: snackbarVariant
  } = useSnackbar();

  Axios.interceptors.request.use(
    function(config) {
      showSpinner();
      return config;
    },
    function(error) {
      hideSpinner();
      return Promise.reject(error);
    }
  );

  Axios.interceptors.response.use(
    response => {
      hideSpinner();

      return response;
    },
    error => {
      hideSpinner();

      // TODO: handle specific http statuses
      const status = error.response && error.response.status;
      if (status) {
        switch (error.response.status) {
          case 400:
            openSnackbar("Došlo je do pogreške.", "error");
            break;
          case 401:
            logoutUser();
            break;
          case 403:
          case 500:
            openSnackbar("Došlo je do pogreške.", "error");
            break;
        }
      }

      return Promise.reject(error);
    }
  );

  const loginPage = () => {
    return location.pathname === loginUrl() ? (
      <>
        <Routing />
        {sharedComponents()}
      </>
    ) : (
      <Redirect to={loginUrl()} />
    );
  };

  const appPage = () => {
    return (
      <div className={"forPdf " + classes.root}>
        <Header />
        <SideNav />
        <main className={classes.content}>
          <div className={classes.appBarSpacer} />
          <Container maxWidth="xl" className={classes.container}>
            <Routing />
            {sharedComponents()}
          </Container>
        </main>
      </div>
    );
  };

  const printPage = () => {
    return (
      <Container maxWidth="xl">
        <Routing />
      </Container>
    );
  };

  const sharedComponents = () => {
    return (
      <>
        <TrSpinner isShown={isSpinnerShown} />
        <TrSnackbar
          variant={snackbarVariant}
          isOpened={isSnackbarOpened}
          message={snackbarMessage}
          onClose={closeSnackbar}
        />
      </>
    );
  };

  if (!user.isAuthenticated) {
    return loginPage();
  } else if (location.pathname.indexOf("/print") !== -1) {
    return printPage();
  } else {
    return appPage();
  }
}
